import React from 'react';
import axios from 'axios';
import qs from 'qs';
import moment from 'moment';
import { DatePicker } from '@material-ui/pickers';
import { withCookies } from 'react-cookie';
import { withSnackbar } from 'notistack';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { ReCaptcha } from 'react-recaptcha-v3';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import PasswordMeter from '../parts/PasswordMeter';
import {
  saveUserToStore,
  googleRecaptcha,
} from '../../helpers';

const styles = () => ({
  button: {
    marginTop: 40,
    padding: '16px 32px',
    backgroundColor: '#f56a12',
    '&:hover': {
      backgroundColor: '#C24C03',
    },
  },
  textField: {
    margin: '8px 0',
  },
});

class ParentSignupPage extends React.Component {
  constructor(props) {
    super(props);

    let minDate = new Date();
    minDate.setFullYear(1995);

    this.state = {
      email: '',
      emailRepeat: '',
      code: '',
      name: '',
      password1: '',
      password2: '',
      isDobDialogOpen: false,
      dob: null,
      minDate: minDate,
    };

    this.onChange = this.onChange.bind(this);
    this.onSignupClick = this.onSignupClick.bind(this);
    this.onDobDialogClose = this.onDobDialogClose.bind(this);
    this.onDobDialogButtonClick = this.onDobDialogButtonClick.bind(this);
  }

  onChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  onSignupClick() {
    const {
      cookies,
      enqueueSnackbar,
    } = this.props;

    axios
      .post(`${window.apiUrl}/hasdob`, qs.stringify({
        email: this.state.email,
        email_repeat: this.state.emailRepeat,
        code: this.state.code,
        name: this.state.name,
        password1: this.state.password1,
        password2: this.state.password2,
      }))
      .then((response) => {
        if (response.data.error) {
          enqueueSnackbar(response.data.error, {
            variant: 'error',
            autoHideDuration: 2000,
          });
        } else if (response.data.data.already_added === true) {
          enqueueSnackbar(t('The pupil was already added to your account.'), {
            variant: 'error',
            autoHideDuration: 2000,
          });
        } else if (response.data.data.has_dob) {
          this.setState({
            isDobDialogOpen: true,
          });
        } else {
          googleRecaptcha('parent_signup', (token) => {
          axios
            .post(`${window.apiUrl}/signup`, qs.stringify({
              email: this.state.email,
              email_repeat: this.state.emailRepeat,
              code: this.state.code,
              name: this.state.name,
              password1: this.state.password1,
              password2: this.state.password2,
              'recaptcha-token': token,
            }))
            .then((signupResponse) => {
              if (signupResponse.data.success) {
                saveUserToStore(signupResponse.data.data);
                enqueueSnackbar('You have successfully signed up.', {
                  variant: 'success',
                  autoHideDuration: 2000,
                });
              } else {
                enqueueSnackbar(signupResponse.data.error, {
                  variant: 'error',
                  autoHideDuration: 2000,
                });
              }
            })
            .catch((thrown) => {});
          });
        }
      })
      .catch((thrown) => {});
  }

  onDobDialogClose() {
    this.setState({
      isDobDialogOpen: false,
    });
  }

  onDobDialogButtonClick() {
    const {
      enqueueSnackbar,
    } = this.props;

    googleRecaptcha('parent_signup', (token) => {
    axios
      .post(`${window.apiUrl}/signup`, qs.stringify({
        email: this.state.email,
        email_repeat: this.state.emailRepeat,
        code: this.state.code,
        name: this.state.name,
        password1: this.state.password1,
        password2: this.state.password2,
        dob: this.state.dob
          ? this.state.dob.format('YYYY-MM-DD')
          : '',
        'recaptcha-token': token,
      }))
      .then((response) => {
        if (response.data.success) {
          const userData = response.data.data;
          saveUserToStore(userData);

          enqueueSnackbar('You have successfully signed up.', {
            variant: 'success',
            autoHideDuration: 2000,
          });
        } else {
          enqueueSnackbar(response.data.error, {
            variant: 'error',
            autoHideDuration: 2000,
          });
        }
      })
      .catch((thrown) => {});
    });
  }

  render() {
    const {
      classes,
      t,
    } = this.props;
    const {
      dob,
      isDobDialogOpen,
      password1,
    } = this.state;

    return (
      <div className="parent-signup-page">
        <TextField
          label={t('Email address')}
          helperText={t('We store this securely in the UK, it\'s used for you to login to the system and shared with the school so they can send you notifications or assist with account login problems.')}
          placeholder={t('Your email address')}
          fullWidth
          margin="normal"
          type="email"
          name="email"
          onChange={this.onChange}
          InputLabelProps={{
            shrink: true,
          }}
          className={classes.textField}
          autoComplete="off"
        />
        <TextField
          label={t('Repeat email address')}
          placeholder={t('Repeat your email address')}
          fullWidth
          margin="normal"
          type="email"
          name="emailRepeat"
          onChange={this.onChange}
          InputLabelProps={{
            shrink: true,
          }}
          className={classes.textField}
          autoComplete="off"
        />
        <TextField
          label={t('Access code (provided by school)')}
          placeholder={t('Your access code')}
          fullWidth
          margin="normal"
          type="text"
          name="code"
          onChange={this.onChange}
          onInput={e => {
            e.target.value = ("" + e.target.value).toUpperCase();
          }}
          InputLabelProps={{
            shrink: true,
          }}
          className={classes.textField}
          autoComplete="off"
        />
        <TextField
          label={t('Name')}
          placeholder={t('Your name')}
          fullWidth
          margin="normal"
          type="text"
          name="name"
          onChange={this.onChange}
          InputLabelProps={{
            shrink: true,
          }}
          className={classes.textField}
          autoComplete="off"
        />
        <TextField
          label={t('Password')}
          placeholder={t('Your password')}
          fullWidth
          margin="normal"
          type="password"
          name="password1"
          onChange={this.onChange}
          InputLabelProps={{
            shrink: true,
          }}
          className={classes.textField}
        />
        <PasswordMeter password={password1} useSuspense={false} />
        <TextField
          label={t('Retype password')}
          placeholder={t('Your retyped password')}
          fullWidth
          margin="normal"
          type="password"
          name="password2"
          onChange={this.onChange}
          InputLabelProps={{
            shrink: true,
          }}
          className={classes.textField}
        />
        <p>
          {t('By clicking the Sign Up button, you agree to our')}
          <span>&nbsp;</span>
          <a href="https://www.edukey.co.uk/privacy/" target="_blank" rel="noopener">{t('Privacy Policy')}</a>
        </p>
        <ReCaptcha
          sitekey={googleRecaptchaSiteKey}
          action="parent_signup"
        />
        <Button
          variant="contained"
          color="primary"
          onClick={this.onSignupClick}
          className={`signup-button ${classes.button}`}
        >
          {t('Sign Up')}
        </Button>
        {/* TODO: replace with the existing DOB dialog */}
        <Dialog
          open={isDobDialogOpen}
          onClose={this.onDobDialogClose}
          aria-labelledby="dob-form-dialog-title"
          className="dob-dialog"
        >
          <DialogTitle id="dob-form-dialog-title">
            {t('Date of birth confirmation')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {t("To confirm you are the parent/carer, please enter your child's date of birth.")}
            </DialogContentText>
            <div style={{ textAlign: 'center' }}>
              <DatePicker
                variant="inline"
                openTo="year"
                minDate={ this.state.minDate }
                maxDate={ new Date() }
                views={['year', 'month', 'date']}
                label={t('Date of Birth')}
                value={dob}
                initialFocusedDate={moment().subtract(14, 'years')}
                onChange={dob => this.setState({ dob })}
                format={dateFormat}
                autoComplete="off"
                disableFuture
                autoOk
                PopoverProps={{
                  anchorOrigin: { horizontal: 'center', vertical: 'center' },
                  transformOrigin: { horizontal: 'center', vertical: 'center' },
                }}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.onDobDialogButtonClick}
              color="primary"
              className="dob-dialog-ok-button"
            >
              {t('Ok')}
            </Button>
            <Button
              onClick={this.onDobDialogClose}
              className="dob-dialog-cancel-button"
            >
              {t('Cancel')}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(withCookies(withSnackbar(withTranslation()(ParentSignupPage))));
